/*
  Filter / sort / paginate for sections/pf-collection.liquid without a page
  reload. Every control is form-associated (form="...") so FormData(form)
  gives the full query. On change we fetch the same URL with section_id
  and swap the toolbar, filter sidebar and results in place; if anything
  fails we fall back to a normal navigation.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pf-collection]');
  if (!root) return;
  /* The cart page's "Continue shopping" link returns here. */
  try { localStorage.setItem('pf:lastCollection', location.pathname); } catch (e) {}
  if (!window.fetch) return;
  var form = document.getElementById(root.dataset.form);
  var sectionId = root.dataset.sectionId;
  if (!form) return;

  function buildUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (v === '' || (k === 'sort_by' && v === root.dataset.defaultSort)) return;
      params.append(k, v);
    });
    var q = params.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }

  function render(url, push) {
    root.classList.add('is-loading');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-pf-toolbar]', '[data-pf-filters]', '[data-pf-results]'].forEach(function (sel) {
          var next = doc.querySelector(sel), cur = root.querySelector(sel);
          if (next && cur) cur.innerHTML = next.innerHTML;
        });
        syncToggle();
        if (push !== false) { window.history.pushState({ pfCollection: true }, '', url); navigated = true; }
        root.classList.remove('is-loading');
      })
      .catch(function () { window.location.href = url; });
  }

  function syncToggle() {
    var btn = root.querySelector('[data-pf-filter-toggle]');
    if (btn) btn.setAttribute('aria-expanded', root.classList.contains('filters-open') ? 'true' : 'false');
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl()); });

  /* Checkboxes and the sort select apply immediately; price inputs wait for Apply. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.form !== form || el.type === 'number') return;
    render(buildUrl());
  });

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pf-filter-toggle]');
    if (toggle) { root.classList.toggle('filters-open'); syncToggle(); return; }
    var link = e.target.closest('[data-pf-filter-link], [data-pf-page]');
    if (!link) return;
    e.preventDefault();
    render(link.getAttribute('href'));
    if (link.hasAttribute('data-pf-page')) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var navigated = false;
  window.addEventListener('popstate', function () {
    if (navigated) render(window.location.pathname + window.location.search, false);
  });

  /* "Read more" on the long description toggles its label. */
  document.addEventListener('toggle', function (e) {
    var t = e.target.querySelector && e.target.querySelector('.pfb-colhead-toggle');
    if (t) t.textContent = e.target.open ? t.dataset.open : t.dataset.closed;
  }, true);
})();
